import classNames from 'classnames';
import React from 'react';

import { PolicyLink } from 'src/widgets/policy/components/PolicyLink';
import { RefundLink } from 'src/widgets/policy/components/RefundLink';
import { TermsLink } from 'src/widgets/policy/components/TermsLink';

import styles from './policy.module.scss';

export type TpPolicyProps = {
  className?: string;
  place: 'paywall' | 'checkout' | 'burger_menu' | 'email_modal';
  withPrefix?: boolean;
};

export const Policy = ({
  className,
  place,
  withPrefix = false,
}: TpPolicyProps) => (
  <span className={classNames(styles.container, className)}>
    {withPrefix && (
      <span className={styles.text}>By continuing you accept the </span>
    )}{' '}
    <TermsLink place={place} />, <PolicyLink place={place} />,{' '}
    <RefundLink place={place} />
  </span>
);
